export enum HostMessageType {
  Init = 'init',
  ResetForm = 'reset-form',
  SetFormToSubmitted = 'set-form-to-submitted',
  SetMode = 'set-mode',
  SetSwiperFocus = 'set-swiper-focus',
  SubmitForm = 'submit-form',
  SwipeData = 'swipe-data',
}
